import { create } from 'zustand';
import { toggleStaffLeave, getStaffLeaveStatus } from '@/services/data/staffLeave';

interface StaffLeaveState {
  isOnLeave: boolean;
  isLoading: boolean;
  fetchLeaveStatus: (staffId: string) => Promise<void>;
  toggleLeave: (staffId: string) => Promise<{
    success: boolean;
    reassigned_count?: number;
    restored_count?: number;
    error?: string;
  }>;
}

export const useStaffLeaveStore = create<StaffLeaveState>((set, get) => ({
  isOnLeave: false,
  isLoading: false,

  fetchLeaveStatus: async (staffId: string) => {
    const result = await getStaffLeaveStatus(staffId);
    if (result.success && result.data) {
      set({ isOnLeave: result.data.is_on_leave });
    }
  },

  toggleLeave: async (staffId: string) => {
    const currentState = get().isOnLeave;
    const action = currentState ? 'deactivate' : 'activate';

    // Optimistic update
    set({ isLoading: true, isOnLeave: !currentState });

    const result = await toggleStaffLeave(staffId, action);

    if (!result.success) {
      // Rollback on failure
      set({ isLoading: false, isOnLeave: currentState });
      return { success: false, error: result.error };
    }

    set({ isLoading: false });
    return {
      success: true,
      reassigned_count: result.data?.reassigned_count,
      restored_count: result.data?.restored_count,
    };
  },
}));
